import { ColumnDef } from '@tanstack/react-table';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';

import { Badge } from '@/components/ui/badge';
import {
  NPS_STATUS_LABELS,
  formatDateRange,
  formatInteger,
  formatParticipationRate,
} from '@/modules/nps/utils';

import CompanyNpsCampaignActionsCell from './CompanyNpsCampaignActionsCell';

export const companyNpsReportColumns: ColumnDef<NpsCampaignDto>[] = [
  {
    accessorKey: 'name',
    header: 'Campanha',
  },
  {
    id: 'periodStart',
    enableHiding: false,
    meta: { className: 'hidden' },
  },
  {
    id: 'periodEnd',
    enableHiding: false,
    meta: { className: 'hidden' },
  },
  {
    id: 'period',
    header: 'Período',
    cell: ({ row }) => formatDateRange(row.original),
    meta: { className: 'hidden md:table-cell' },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => (
      <Badge
        variant={row.original.status === 'closed' ? 'outline' : 'secondary'}
      >
        {NPS_STATUS_LABELS[row.original.status]}
      </Badge>
    ),
  },
  {
    accessorKey: 'responsesCount',
    header: 'Respostas',
    cell: ({ row }) => formatInteger(row.original.responsesCount),
    meta: { className: 'text-right' },
  },
  {
    accessorKey: 'eligibleUsersCount',
    header: 'Elegíveis',
    cell: ({ row }) => formatInteger(row.original.eligibleUsersCount),
    meta: { className: 'hidden text-right xl:table-cell' },
  },
  {
    id: 'participation',
    header: 'Participação',
    cell: ({ row }) => formatParticipationRate(row.original),
    meta: { className: 'hidden text-right md:table-cell' },
  },
  {
    id: 'actions',
    header: 'Relatórios',
    meta: {
      className: 'text-right',
      onClick: (event) => event.stopPropagation(),
    },
    cell: ({ row }) => (
      <CompanyNpsCampaignActionsCell campaign={row.original} />
    ),
  },
];
